!function(){"use strict";let e={storeId:"QuainTees",webhookUrl:"https://app.podautomate.com/webhook/9982ccbd-36d0-49ba-8f79-9c307d34e3e2",analyticsUrl:"https://script.google.com/macros/s/AKfycbzqSpmuFnfCSeVSo3jguIEPnGul15054Uy_nKhDyOzIuTFPVajhGSnrngldntOcEemc/exec",variantApiUrl:"https://script.google.com/macros/s/AKfycbzqSpmuFnfCSeVSo3jguIEPnGul15054Uy_nKhDyOzIuTFPVajhGSnrngldntOcEemc/exec",abTesting:{enabled:!0,minSessionsPerVariant:500,optimizationMode:"winner-only",epsilonValue:.2},variants:[{id:"variant-a-control",name:"Control - Modal Layout",weight:1,config:{layoutType:"modal",logoUrl:"https://quaintees.com/cdn/shop/files/Quaintees_Logo_3c107a3a-bb69-4a3e-b546-df6836a98d0d.png",productImageUrl:"https://quaintees.com/cdn/shop/files/selfie-of-a-beautiful-girl-wearing-a-t-shirt-mockup-while-smiling-a16906.png",backgroundImageDesktop:"https://quaintees.com/cdn/shop/files/desktop-background.jpg",backgroundImageMobile:"https://quaintees.com/cdn/shop/files/mobile-background.jpg",textMode:"dark",step1Headline:"Do You Want A Mystery Discount?",step2Headline:"Unlock Your Mystery Discount",step2Subtext:"",step3Headline:"Your Discount Is On Its Way...",step3Text:"Please check your inbox for the confirmation message with your mystery discount code.",step3SubText:"Haven't received a message within 5 minutes? Please check your spam box or promotions tab/folder.",buttonTexts:["Yes Please!"],submitText:"Claim My Deal",declineText:"No thanks, I want to pay full price.",emailPlaceholder:"Enter Your Email Here",teaserText:"\uD83C\uDF81 Mystery Discount"}},{id:"variant-b-fullscreen",name:"Fullscreen Dark Background",weight:1,config:{layoutType:"fullscreen",logoUrl:"https://quaintees.com/cdn/shop/files/Quaintees_Logo_3c107a3a-bb69-4a3e-b546-df6836a98d0d.png",productImageUrl:"",backgroundImageDesktop:"https://images.unsplash.com/photo-1557683316-973673baf926?w=1920",backgroundImageMobile:"https://images.unsplash.com/photo-1557683316-973673baf926?w=800",textMode:"light",step1Headline:"Get Your Mystery Discount",step2Headline:"Unlock Your Savings",step2Subtext:"Enter your email to reveal your discount code",step3Headline:"Check Your Inbox!",step3Text:"Your discount code is waiting for you.",step3SubText:"Can't find it? Check spam or promotions.",buttonTexts:["For Myself","As A Gift","Just Browsing"],submitText:"Get My Code",declineText:"No thanks",emailPlaceholder:"Your Email",teaserText:"\uD83C\uDF81 Claim Discount"}},{id:"variant-c-benefit",name:"Benefit - Modal Layout",weight:1,config:{layoutType:"modal",logoUrl:"https://quaintees.com/cdn/shop/files/Quaintees_Logo_3c107a3a-bb69-4a3e-b546-df6836a98d0d.png",productImageUrl:"https://quaintees.com/cdn/shop/files/selfie-of-a-beautiful-girl-wearing-a-t-shirt-mockup-while-smiling-a16906.png",backgroundImageDesktop:"",backgroundImageMobile:"",textMode:"dark",step1Headline:"Save More On Your First Order",step2Headline:"Enter Your Email For Instant Savings",step2Subtext:"Join thousands of happy customers saving money",step3Headline:"You're All Set!",step3Text:"Check your email for your personal discount code and start saving.",step3SubText:"Email not there? Look in spam or promotions.",buttonTexts:["I Want To Save!"],submitText:"Send My Discount",declineText:"Skip the savings",emailPlaceholder:"Enter Email Address",teaserText:"\uD83D\uDCB0 Save Money"}},],delaySeconds:6,showOnce:!0,exitIntent:!0,scrollPercent:60,suppressForLoggedInCustomers:!0,accountCheckTimeoutMs:2e3,testMode:!0,excludedPages:["/cart","/checkout","/account","/account/login","/account/register",],includedPages:["/policies/privacy-policy",]},t="quaintee_popup_shown",n="quaintee_form_completed",a="quaintee_force_popup",i="quaintee_session_id",o="quaintee_human_verified",r="quaintee_variant_id",s=e.showOnce?localStorage:sessionStorage;function l(){if(navigator.webdriver||/HeadlessChrome/i.test(navigator.userAgent)||window.document.documentElement.getAttribute("webdriver")||window.callPhantom||window._phantom||window.Buffer||!navigator.languages||0===navigator.languages.length)return!0;let e=navigator.userAgent;return!(e&&!(e.length<50)&&/Mozilla/i.test(e))}function p(){let e=sessionStorage.getItem(i);return e||(e="sess_"+Date.now()+"_"+Math.random().toString(36).substr(2,9),sessionStorage.setItem(i,e)),e}let u=!1,c=0;function d(){u||(u=!0,sessionStorage.setItem(o,"true"))}async function g(t,n={}){if(!e.analyticsUrl)return;let a={is_bot:l(),webdriver:!!navigator.webdriver,headless:/HeadlessChrome/i.test(navigator.userAgent),languages:navigator.languages?navigator.languages.length:0,plugins:navigator.plugins?navigator.plugins.length:0,ua_length:navigator.userAgent.length};if(a.is_bot){console.log("Bot detected, skipping analytics");return}if(["popup_impression","form_submission"].includes(t)){let i="true"===sessionStorage.getItem(o);if(!i&&c<2){console.log("Insufficient human interaction, skipping analytics");return}}let s={store_id:e.storeId,timestamp:new Date().toISOString(),event_type:t,url:window.location.href,referrer:document.referrer||"direct",user_agent:navigator.userAgent,session_id:p(),variant_id:sessionStorage.getItem(r)||"unknown",viewport_width:window.innerWidth,viewport_height:window.innerHeight,screen_width:window.screen.width,screen_height:window.screen.height,timezone:Intl.DateTimeFormat().resolvedOptions().timeZone,...a,mouse_movements:c,...n};try{await fetch(e.analyticsUrl,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(s),mode:"no-cors"})}catch(u){console.error("Analytics tracking error:",u)}}async function m(){if(!e.abTesting.enabled)return e.variants;try{let t=await fetch(`${e.variantApiUrl}?action=get_variants&store_id=${e.storeId}`,{method:"GET",cache:"no-store"});if(t.ok){let n=await t.json();if(n.eligible_variants&&n.eligible_variants.length>0){let a=n.eligible_variants.map(e=>e.variant_id);return e.variants.filter(e=>a.includes(e.id))}}}catch(i){console.log("Variant API error, using all variants:",i)}return e.variants}document.addEventListener("mousemove",()=>{++c>3&&d()},{passive:!0,once:!1}),document.addEventListener("click",d,{passive:!0}),document.addEventListener("touchstart",d,{passive:!0});let $=document.createElement("style");function f(e){sessionStorage.setItem(r,e),sessionStorage.removeItem(t),sessionStorage.removeItem(n),window.location.reload()}function b(e){let t=document.querySelectorAll(".quaintee-test-teaser");t.forEach(t=>{let n=t.getAttribute("data-variant-id");n===e?t.classList.add("active-variant"):t.classList.remove("active-variant")})}async function h(){let t=function e(){try{let t=window?.ShopifyAnalytics?.meta?.page?.customerId;return t?String(t):null}catch(n){return null}}();if(t)return!0;if(!e.accountCheckTimeoutMs||0===e.accountCheckTimeoutMs)return!1;try{var n,a;let i=await (n=fetch("/account",{method:"GET",credentials:"include",cache:"no-store",redirect:"follow",headers:{Accept:"text/html"}}),a=e.accountCheckTimeoutMs,Promise.race([n,new Promise(e=>setTimeout(()=>e(null),a)),]));if(!i)return!1;let o=(i.url||"").toLowerCase();if(o.includes("/account/login"))return!1;if(i.ok)return!0;return!1}catch(r){return!1}}async function y(){if(l()){console.log("Bot detected, exiting");return}if(function t(){let n=window.location.pathname.toLowerCase();if(e.includedPages&&e.includedPages.length>0){let a=e.includedPages.some(e=>{let t=e.toLowerCase();return!!(n===t||n.startsWith(t))});return!a}return e.excludedPages.some(e=>{let t=e.toLowerCase();return!!(n===t||n.startsWith(t))})}()){console.log("Page excluded from popup:",window.location.pathname);return}let i=null;e.suppressForLoggedInCustomers&&(i=h());let o=function t(){let n=sessionStorage.getItem(r);if(n){let a=e.variants.find(e=>e.id===n);if(a)return a}return null}();if(o)console.log("Using cached variant:",o.name,"("+o.id+")");else{let u=await m();o=function e(t){let n=sessionStorage.getItem(r);if(n){let a=t.find(e=>e.id===n);if(a)return a}let i=t.reduce((e,t)=>e+(t.weight||1),0),o=Math.random()*i;for(let s of t)if((o-=s.weight||1)<=0)return sessionStorage.setItem(r,s.id),s;let l=t[0];return sessionStorage.setItem(r,l.id),l}(u),console.log("Selected variant (from API):",o.name,"("+o.id+")")}if(i){let c=await i;if(c){console.log("Logged in customer, skipping popup");return}}let $=s.getItem(a);if($)s.removeItem(a);else if(s.getItem(t)){s.getItem(n)||function e(i){if(document.getElementById("quainteeTeaser"))return;let o=`
      <div class="quaintee-teaser active" id="quainteeTeaser">
        <div class="quaintee-teaser-text">${i.config.teaserText}</div>
      </div>
    `,r=document.createElement("div");r.innerHTML=o,document.body.appendChild(r.firstElementChild);let l=document.getElementById("quainteeTeaser");l&&l.addEventListener("click",()=>{s.removeItem(t),s.removeItem(n),s.setItem(a,"true"),window.location.reload()})}(o);return}let f=document.createElement("div");for(f.innerHTML=function e(t){let n=t.config,a="fullscreen"===n.layoutType,i=a?`text-${n.textMode}`:"",o=n.buttonTexts||[n.buttonText||"Continue"],r=o.filter(e=>e&&""!==e.trim()),s=r.length>1,l=r.map((e,t)=>`<button class="quaintee-popup-button step1-button" data-button-index="${t}">${e}</button>`).join(""),p=a?"":`<div class="quaintee-popup-image" style="background-image: url('${n.productImageUrl}');"></div>`;return`
      <div class="quaintee-popup-overlay" id="quainteePopup">
        <div class="quaintee-popup layout-${n.layoutType} ${i}" id="quainteePopupContainer">
          ${a?'<div class="quaintee-popup-close" id="quainteeClose" title="Close"></div>':""}
          ${p}
          
          <div class="quaintee-popup-content">
            <img src="${n.logoUrl}" alt="Logo" class="quaintee-popup-logo">
            
            <div class="quaintee-popup-step step-1 active">
              <h2>${n.step1Headline}</h2>
              <div class="quaintee-popup-buttons-container ${s?"multi-choice":""}">
                ${l}
              </div>
              <a href="#" class="quaintee-popup-decline" id="decline1">${n.declineText}</a>
            </div>

            <div class="quaintee-popup-step step-2">
              <h2>${n.step2Headline}</h2>
              ${n.step2Subtext?`<p>${n.step2Subtext}</p>`:""}
              <form id="quainteeEmailForm">
                <input 
                  type="email" 
                  name="email" 
                  id="quainteeEmail"
                  placeholder="${n.emailPlaceholder}" 
                  required
                  autocomplete="email"
                >
                <button type="submit" class="quaintee-popup-button">${n.submitText}</button>
              </form>
              <a href="#" class="quaintee-popup-decline" id="decline2">${n.declineText}</a>
            </div>

            <div class="quaintee-popup-step step-3">
              <h2>${n.step3Headline}</h2>
              <p>${n.step3Text}</p>
              <p>${n.step3SubText}</p>
              <button class="quaintee-popup-button" id="successClose" style="margin-top: 20px;">Continue Shopping</button>
            </div>
          </div>
        </div>
      </div>

      <div class="quaintee-teaser" id="quainteeTeaser">
        <div class="quaintee-teaser-text">${n.teaserText}</div>
      </div>
    `}(o);f.firstChild;)document.body.appendChild(f.firstChild);let b=document.getElementById("quainteePopup"),y=document.getElementById("quainteePopupContainer"),x=document.querySelectorAll(".step1-button"),v=document.getElementById("decline1"),q=document.getElementById("decline2"),_=document.getElementById("quainteeEmailForm"),k=document.getElementById("quainteeTeaser"),w=document.getElementById("successClose"),T=document.getElementById("quainteeClose");if(!b||0===x.length||!v||!q||!_||!k)return;if(e.testMode){let I=function e(t,n){let a=t.map(e=>{let t=e.id===n;return`
        <div class="quaintee-test-teaser ${t?"active-variant":""}" data-variant-id="${e.id}">
          <div class="quaintee-test-teaser-name">${e.name}</div>
          <div class="quaintee-test-teaser-id">${e.id}</div>
        </div>
      `}).join("");return`
      <div class="quaintee-test-teasers active" id="quainteeTestTeasers">
        <div class="quaintee-test-teaser-label">🧪 Test Mode - Click to Preview:</div>
        ${a}
      </div>
    `}(e.variants,o.id),E=document.createElement("div");E.innerHTML=I,document.body.appendChild(E.firstElementChild);let S=document.querySelectorAll(".quaintee-test-teaser");S.forEach(e=>{e.addEventListener("click",()=>{let a=e.getAttribute("data-variant-id");a&&(sessionStorage.setItem(r,a),sessionStorage.removeItem(t),sessionStorage.removeItem(n),window.location.reload())})}),console.log("\uD83E\uDDEA Test Mode enabled - Click teasers at bottom to preview variants")}if("fullscreen"===o.config.layoutType&&y){let L=window.innerWidth<=860,C=L?o.config.backgroundImageMobile:o.config.backgroundImageDesktop;y.style.backgroundImage=`url('${C}')`}let M=!1,A="delay";function P(e){document.querySelectorAll(".quaintee-popup-step").forEach(e=>{e.classList.remove("active")});let t=document.querySelector(`.quaintee-popup-step.step-${e}`);t&&t.classList.add("active")}function z(e=!0){b.classList.remove("active"),document.body.style.overflow="",e&&!M&&k.classList.add("active")}function U(e){A=e,b.classList.add("active"),s.setItem(t,"true"),document.body.style.overflow="hidden",g("popup_impression",{trigger_type:e,logged_in_status:"visitor",variant_name:o.name,layout_type:o.config.layoutType})}let D=null;if(e.testMode?U("test_mode"):$?U("teaser_reopen"):D=setTimeout(()=>{k.classList.contains("active")||U("delay")},1e3*e.delaySeconds),x.forEach((e,t)=>{e.addEventListener("click",()=>{d();let t=e.textContent,n=e.getAttribute("data-button-index");g("step_1_button_click",{variant_name:o.name,button_text:t,button_index:n,layout_type:o.config.layoutType}),P(2)})}),v.addEventListener("click",e=>{e.preventDefault(),g("decline_step_1",{trigger_type:A,variant_name:o.name,layout_type:o.config.layoutType}),z(!0)}),q.addEventListener("click",e=>{e.preventDefault(),g("decline_step_2",{trigger_type:A,variant_name:o.name,layout_type:o.config.layoutType}),z(!0)}),w&&w.addEventListener("click",()=>{z(!1)}),T&&T.addEventListener("click",()=>{g("close_button_click",{trigger_type:A,variant_name:o.name,layout_type:o.config.layoutType}),z(!0)}),b.addEventListener("click",e=>{e.target===b&&z(!0)}),k.addEventListener("click",()=>{M=!1,b.classList.add("active"),P(1),document.body.style.overflow="hidden",k.classList.remove("active")}),e.exitIntent&&!$){let H=!1,O=e=>{window.innerWidth<768||!(e.clientY<=0)||H||b.classList.contains("active")||k.classList.contains("active")||M||(H=!0,D&&clearTimeout(D),U("exit_intent"),document.removeEventListener("mouseout",O))};document.addEventListener("mouseout",O)}if(e.scrollPercent>0&&!$){let Y=!1,B=()=>{if(Y)return;let t=window.pageYOffset||document.documentElement.scrollTop,n=document.documentElement.scrollHeight-document.documentElement.clientHeight,a=t/n*100;!(a>=e.scrollPercent)||b.classList.contains("active")||k.classList.contains("active")||M||(Y=!0,D&&clearTimeout(D),U("scroll_"+Math.round(a)+"%"),window.removeEventListener("scroll",B))};window.addEventListener("scroll",B,{passive:!0})}_.addEventListener("submit",async t=>{t.preventDefault(),d();let a=_.querySelector('button[type="submit"]'),i=document.getElementById("quainteeEmail").value;a.disabled=!0,a.textContent="Submitting...";try{let r=await fetch(e.webhookUrl,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({email:i,source:"mystery_discount_popup",popup_step:"email_capture",url:window.location.href,user_agent:navigator.userAgent,timestamp:new Date().toISOString(),referrer:document.referrer||"direct",trigger_type:A,session_id:p(),store_id:e.storeId,variant_id:o.id,variant_name:o.name,layout_type:o.config.layoutType})});if(!r.ok)throw Error(`HTTP error! status: ${r.status}`);g("form_submission",{email:i,trigger_type:A,logged_in_status:"visitor",variant_name:o.name,layout_type:o.config.layoutType}),M=!0,s.setItem(n,"true"),P(3)}catch(l){g("form_error",{error:l.message,trigger_type:A,variant_name:o.name,layout_type:o.config.layoutType}),alert("Something went wrong. Please try again."),a.disabled=!1,a.textContent=o.config.submitText}})}$.textContent=`
    /* ===== MODAL LAYOUT (EXISTING) ===== */
    .quaintee-popup-overlay {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.75);
      z-index: 999999;
      justify-content: center;
      align-items: center;
      animation: fadeIn 0.3s ease;
    }

    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    .quaintee-popup-overlay.active {
      display: flex;
    }

    /* Modal Layout */
    .quaintee-popup.layout-modal {
      background: white;
      width: 820px;
      height: 540px;
      display: flex;
      border-radius: 0;
      overflow: hidden;
      position: relative;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    }

    .quaintee-popup.layout-modal .quaintee-popup-image {
      width: 300px !important;
      height: 540px !important;
      flex-shrink: 0;
      background-size: cover !important;
      background-position: center !important;
      background-repeat: no-repeat !important;
      display: block !important;
    }

    .quaintee-popup.layout-modal .quaintee-popup-content {
      flex: 1;
      padding: 60px 50px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      background: white;
    }

    /* ===== FULLSCREEN LAYOUT (NEW) ===== */
    .quaintee-popup.layout-fullscreen {
      width: 100vw;
      height: 100vh;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      overflow-y: auto;
    }

    .quaintee-popup.layout-fullscreen::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.4);
      z-index: 0;
    }

    /* Close button for fullscreen */
    .quaintee-popup-close {
      display: none;
      position: absolute;
      top: 20px;
      right: 20px;
      width: 44px;
      height: 44px;
      background: rgba(0, 0, 0, 0.5);
      border: 2px solid rgba(255, 255, 255, 0.3);
      border-radius: 50%;
      cursor: pointer;
      z-index: 10;
      transition: all 0.2s;
      justify-content: center;
      align-items: center;
    }

    .quaintee-popup.layout-fullscreen .quaintee-popup-close {
      display: flex;
    }

    .quaintee-popup-close:hover {
      background: rgba(0, 0, 0, 0.7);
      transform: scale(1.1);
      border-color: rgba(255, 255, 255, 0.6);
    }

    .quaintee-popup-close::before,
    .quaintee-popup-close::after {
      content: '';
      position: absolute;
      width: 20px;
      height: 2px;
      background: #ffffff;
    }

    .quaintee-popup-close::before {
      transform: rotate(45deg);
    }

    .quaintee-popup-close::after {
      transform: rotate(-45deg);
    }

    /* Text mode variations for close button */
    .quaintee-popup.layout-fullscreen.text-light .quaintee-popup-close {
      background: rgba(255, 255, 255, 0.15);
      border-color: rgba(255, 255, 255, 0.4);
    }

    .quaintee-popup.layout-fullscreen.text-light .quaintee-popup-close:hover {
      background: rgba(255, 255, 255, 0.25);
      border-color: rgba(255, 255, 255, 0.7);
    }

    .quaintee-popup.layout-fullscreen.text-dark .quaintee-popup-close {
      background: rgba(0, 0, 0, 0.15);
      border-color: rgba(0, 0, 0, 0.3);
    }

    .quaintee-popup.layout-fullscreen.text-dark .quaintee-popup-close:hover {
      background: rgba(0, 0, 0, 0.25);
      border-color: rgba(0, 0, 0, 0.5);
    }

    .quaintee-popup.layout-fullscreen.text-dark .quaintee-popup-close::before,
    .quaintee-popup.layout-fullscreen.text-dark .quaintee-popup-close::after {
      background: #000000;
    }

    .quaintee-popup.layout-fullscreen .quaintee-popup-content {
      position: relative;
      z-index: 1;
      padding: 60px 40px;
      max-width: 600px;
      width: 90%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
    }

    .quaintee-popup.layout-fullscreen .quaintee-popup-image {
      display: none !important;
    }

    /* Text color modes for fullscreen */
    .quaintee-popup.layout-fullscreen.text-light h2,
    .quaintee-popup.layout-fullscreen.text-light p,
    .quaintee-popup.layout-fullscreen.text-light .quaintee-popup-decline {
      color: #ffffff;
    }

    .quaintee-popup.layout-fullscreen.text-light input[type="email"] {
      background: rgba(255, 255, 255, 0.9);
      border-color: #ffffff;
      color: #000000;
    }

    .quaintee-popup.layout-fullscreen.text-light input[type="email"]::placeholder {
      color: rgba(0, 0, 0, 0.5) !important;
    }

    .quaintee-popup.layout-fullscreen.text-light input[type="email"]:focus {
      background: rgba(255, 255, 255, 1);
    }

    .quaintee-popup.layout-fullscreen.text-dark h2,
    .quaintee-popup.layout-fullscreen.text-dark p,
    .quaintee-popup.layout-fullscreen.text-dark .quaintee-popup-decline {
      color: #2d3748;
    }

    .quaintee-popup.layout-fullscreen.text-dark input[type="email"] {
      background: rgba(255, 255, 255, 0.95);
      border-color: #000000;
      color: #000000;
    }

    .quaintee-popup.layout-fullscreen.text-dark input[type="email"]::placeholder {
      color: rgba(0, 0, 0, 0.4) !important;
    }

    /* ===== SHARED STYLES ===== */
    .quaintee-popup-logo {
      width: 220px;
      height: auto;
      margin-bottom: 50px;
      object-fit: contain;
    }

    .quaintee-popup h2 {
      font-size: 36px;
      font-weight: 700;
      font-family: Arial, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
      color: #2d3748;
      margin: 0 0 20px 0;
      line-height: 1.2;
    }

    .quaintee-popup p {
      font-size: 16px;
      color: #718096;
      margin: 0 0 30px 0;
      line-height: 1.5;
    }

    .quaintee-popup-button {
      width: 100%;
      padding: 18px 40px;
      background: #000;
      color: white;
      border: none;
      border-radius: 4px;
      font-size: 24px;
      font-weight: 700;
      font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", Arial, sans-serif;
      cursor: pointer;
      transition: all 0.2s;
      text-transform: none;
      letter-spacing: 0.5px;
    }

    .quaintee-popup-button:hover {
      background: #333;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }

    .quaintee-popup-button:disabled {
      background: #999;
      cursor: not-allowed;
      transform: none;
    }

    .quaintee-popup-buttons-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .quaintee-popup-buttons-container.multi-choice {
      gap: 10px;
    }

    .quaintee-popup-buttons-container.multi-choice .quaintee-popup-button {
      padding: 14px 30px;
      font-size: 16px;
    }

    .quaintee-popup input[type="email"] {
      width: 100%;
      padding: 16px 20px;
      border: 2px solid #000;
      border-radius: 4px;
      font-size: 16px;
      margin-bottom: 20px;
      box-sizing: border-box;
      transition: all 0.2s;
      background: #f8f9fa;
    }

    .quaintee-popup input[type="email"]:focus {
      outline: none;
      border-color: #000;
      background: #fff;
      box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
    }

    .quaintee-popup input[type="email"]::placeholder {
      color: #6c757d;
      font-weight: 500;
    }

    .quaintee-popup-decline {
      margin-top: 10px;
      color: #a0aec0;
      font-size: 16px;
      font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", Arial, sans-serif;
      cursor: pointer;
      text-decoration: none;
      transition: color 0.2s;
      display: inline-block;
    }

    .quaintee-popup-decline:hover {
      color: #718096;
      text-decoration: underline;
    }

    .quaintee-popup-step {
      display: none;
      width: 100%;
    }

    .quaintee-popup-step.active {
      display: block;
    }

    .quaintee-popup-step.step-3 p {
      font-size: 15px;
      line-height: 1.6;
      margin-bottom: 15px;
    }

    .quaintee-popup-step.step-3 p:last-child {
      font-size: 13px;
      color: #a0aec0;
    }

    .quaintee-teaser {
      position: fixed;
      bottom: 20px;
      left: 20px;
      background: #000;
      color: white;
      padding: 15px 25px;
      border-radius: 4px;
      cursor: pointer;
      z-index: 999998;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
      transition: all 0.2s;
      display: none;
    }

    .quaintee-teaser.active {
      display: block;
      animation: slideInLeft 0.4s ease;
    }

    @keyframes slideInLeft {
      from {
        transform: translateX(-100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }

    .quaintee-teaser:hover {
      background: #333;
      transform: scale(1.05);
    }

    .quaintee-teaser-text {
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 0.5px;
    }

    /* ===== TEST MODE STYLES ===== */
    .quaintee-test-teasers {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.95), rgba(0, 0, 0, 0.85));
      padding: 15px 20px;
      z-index: 999997;
      display: none;
      flex-wrap: wrap;
      gap: 10px;
      justify-content: center;
      align-items: center;
      box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.3);
      border-top: 2px solid rgba(255, 255, 255, 0.2);
    }

    .quaintee-test-teasers.active {
      display: flex;
    }

    .quaintee-test-teaser-label {
      color: rgba(255, 255, 255, 0.6);
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 1px;
      margin-right: 10px;
    }

    .quaintee-test-teaser {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      padding: 12px 20px;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.2s;
      font-size: 14px;
      font-weight: 600;
      border: 2px solid rgba(255, 255, 255, 0.2);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      min-width: 120px;
    }

    .quaintee-test-teaser:hover {
      transform: translateY(-3px);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
      border-color: rgba(255, 255, 255, 0.5);
    }

    .quaintee-test-teaser-name {
      font-size: 13px;
      font-weight: 700;
      text-align: center;
    }

    .quaintee-test-teaser-id {
      font-size: 10px;
      opacity: 0.7;
      text-align: center;
    }

    .quaintee-test-teaser.active-variant {
      background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
      border-color: rgba(255, 255, 255, 0.8);
      box-shadow: 0 0 20px rgba(245, 87, 108, 0.5);
    }

    /* ===== RESPONSIVE ===== */
    @media (max-width: 860px) {
      .quaintee-popup.layout-modal {
        flex-direction: column;
        width: 90%;
        height: auto;
        max-height: 90vh;
        overflow-y: auto;
      }

      .quaintee-popup.layout-modal .quaintee-popup-image {
        width: 100% !important;
        height: 250px !important;
        min-height: 250px;
        flex: none;
      }

      .quaintee-popup.layout-modal .quaintee-popup-content {
        padding: 40px 30px;
      }

      .quaintee-popup.layout-fullscreen .quaintee-popup-content {
        padding: 40px 30px;
      }

      .quaintee-popup.layout-fullscreen .quaintee-popup-close {
        top: 15px;
        right: 15px;
        width: 40px;
        height: 40px;
      }

      .quaintee-popup.layout-fullscreen .quaintee-popup-close::before,
      .quaintee-popup.layout-fullscreen .quaintee-popup-close::after {
        width: 18px;
      }

      .quaintee-popup h2 {
        font-size: 28px;
      }

      .quaintee-popup-logo {
        width: 150px;
        margin-bottom: 25px;
      }

      .quaintee-teaser {
        bottom: 10px;
        left: 10px;
        padding: 12px 20px;
        font-size: 14px;
      }
    }
  `,document.head.appendChild($),"loading"===document.readyState?document.addEventListener("DOMContentLoaded",y):y()}();